"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { useState } from "react";
import { ApiEnv } from "@/utils/config";

export default function ReactQueryProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const showDevTools = process.env.NEXT_PUBLIC_API_ENV === ApiEnv.LOCAL || process.env.NEXT_PUBLIC_API_ENV === ApiEnv.DEV;
  
  // Ensure a single QueryClient instance per provider with improved default options
  const [queryClient] = useState(() => new QueryClient({
    defaultOptions: {
      queries: {
        // Only keep data fresh for 30 seconds to ensure timely updates
        staleTime: 1000 * 30,
        // Don't retry failed queries too many times
        retry: 1,
        // Don't refetch on window focus for better UX
        refetchOnWindowFocus: false,
        // Ensure data is refetched when navigating back to a page
        refetchOnMount: true,
        // Ensure data is refetched when reconnecting
        refetchOnReconnect: true,
      },
      mutations: {
        // Don't retry failed mutations
        retry: false,
      },
    },
  }));
  
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {showDevTools && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
}
